import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export const useSellersGeoMapStyles = () => {
  return useStyles(({theme, mediaOnly, addShadow}) => ({
    container: {
      position: 'relative',
      marginTop: 30,
      marginBottom: 8,
      overflow: 'hidden',

      ...mediaOnly(
        DeviceSize.desktop,
        {
          borderRadius: 40,
          flexDirection: 'row',
          alignItems: 'stretch',
          ...addShadow({
            opacity: 0.05,
            width: 0,
            height: 4,
            radius: 10,
          }),
        },
        {
          borderRadius: 32,
        },
      ),
    },
    map: mediaOnly(DeviceSize.desktop, {
      minHeight: 650,
      flexShrink: 1,
      flexGrow: 1,
    }),
    alertContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      zIndex: 1,
    },
    overlay: {
      position: 'absolute',
      display: 'flex',
      width: '100%',
      height: '100%',
      backgroundColor: theme.color.primaryBlackColor,
      opacity: 0.4,
      zIndex: 1,
    },
    alertCard: {
      position: 'absolute',
      shadowRadius: 10,
      shadowOpacity: 0.5,
      shadowColor: theme.color.shaddowBg,
      borderRadius: 14,
      backgroundColor: 'white',
      paddingVertical: 20,
      paddingHorizontal: 46,
      flexShrink: 0,
      width: '50%',
      height: 'fit-content',
      opacity: 1,
      zIndex: 2,
    },
    alertText: {
      color: theme.color.textColor,
    },
  }));
};
